import { useEffect, useState } from "react";

export const useActiveCategory = () => {
  const [category, setCategory] = useState(
    localStorage.getItem("activeStepCategory") || ""
  );

  useEffect(() => {
    const handleChange = (event) => {
      if (event.type === "storage") {
        if (event.key === "activeStepCategory") {
          setCategory(event.newValue);
        }
      }

      if (event.type === "localStorageChange") {
        setCategory(localStorage.getItem("activeStepCategory"));
      }
    };

    window.addEventListener("storage", handleChange);
    window.addEventListener("localStorageChange", handleChange);

    return () => {
      window.removeEventListener("storage", handleChange);
      window.removeEventListener("localStorageChange", handleChange);
    };
  }, []);

  return category;
};